module.exports = __webpack_public_path__ + "src/fonts/NotoSans-Italic.6c844690e23f993cf8e437286e46416d.ttf";